'use client';


import Header from '@/components/common/Header';
import StatsOverview from './components/StatsOverview';
import PerformanceChart from './components/PerformanceChart';
import DailyDealsInteractive from './components/DailyDealsInteractive';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

export default function DailyDealsCompletedPage() {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <div className="flex items-center space-x-3 mb-4">
              <div className="p-3 bg-primary/10 rounded-lg">
                <Icon name="DocumentCheckIcon" size={32} variant="solid" className="text-primary" />
              </div>
              <div>
                <h1 className="text-4xl md:text-5xl font-heading font-bold text-foreground">
                  {t('dailyDeals.title')}
                </h1>
                <p className="text-lg text-muted-foreground mt-2">
                  {t('dailyDeals.subtitle')}
                </p>
              </div>
            </div>
            <p className="text-foreground leading-relaxed max-w-3xl">
              {t('dailyDeals.description')}
            </p>
          </div>

          <div className="mb-12">
            <DailyDealsInteractive />
          </div>

          <div className="mb-12">
            <StatsOverview />
          </div>

          <div className="mb-12">
            <PerformanceChart />
          </div>

          <div className="mb-8">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl font-heading font-bold text-foreground">{t('dailyDeals.recentDeals')}</h2>
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <Icon name="ClockIcon" size={16} variant="outline" />
                <span>{t('common.updatedDaily')}</span>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footer className="bg-card border-t border-border py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-sm text-muted-foreground">
              &copy; {new Date()?.getFullYear()} {t('common.companyName')}. {t('common.allRightsReserved')}
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                {t('common.privacyPolicy')}
              </a>
              <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                {t('common.termsOfService')}
              </a>
              <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                {t('common.contact')}
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}